import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from './CouponPrivacyProvideModal.module.scss';
export default function PrivacyProvideCoupon() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.container}><Text as="p" category="caption" variant="m1" color="var(--color-gray-900)">서비스(회사): 이실장(프롭티어(주))</Text><Text as="p" category="body" variant="r2" color="var(--color-gray-700)">서비스의 개인정보 수집 이용 목적은 다음과 같습니다. 내용을 자세히 읽어 보신 후 동의 여부를 결정하여 주시기 바랍니다.</Text></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <th scope="row"><div className={styles.tableCell}><Text category="caption" variant="sb2" color="var(--color-gray-600)">수집 목적</Text></div></th>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <tr>{t1}<td><div className={styles.tdCell}><Text as="p" category="caption" variant="sb2" color="var(--color-gray-800)">안심케어 할인 혜택 제공 및 이용 안내를 위한 알림톡 발송</Text></div></td></tr>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <th scope="row"><div className={styles.tableCell}><Text category="caption" variant="sb2" color="var(--color-gray-600)">수집 항목</Text></div></th>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <tr>{t3}<td><div className={styles.tdCell}><Text category="body" variant="r3" color="var(--color-gray-800)">휴대폰번호</Text></div></td></tr>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <th scope="row"><div className={styles.tableCell}><Text category="caption" variant="sb2" color="var(--color-gray-600)">보유· 이용기간</Text></div></th>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <table className={styles.table}><tbody>{t2}{t4}<tr>{t5}<td><div className={styles.tdCell}><Text category="caption" variant="sb2" color="var(--color-gray-800)">수집일로부터 3개월 까지</Text></div></td></tr></tbody></table>;
    t7 = <Text as="p" category="body" variant="r3" color="var(--color-gray-700)">자세한 내용은 아래 개인정보처리방침을 확인해주세요.</Text>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div>{t7}<Link href="https://www.aipartner.com/html/privacy" target="_blank" rel="noopener noreferrer"><Text className={styles.link} as="p" category="body" variant="r3" color="var(--color-gray-900)">https://www.aipartner.com/html/privacy</Text></Link></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={styles.PrivacyProvideCouponSheet}>{t0}{t6}{t8}<div className={styles.description}><Text as="p" category="body" variant="r3" color="var(--color-gray-700)">귀하는 위와 같이 개인정보를 수집 · 이용하는데 동의를 거부할 권리가 있습니다. 단, 동의를 거부하실 경우 안심케어 할인 쿠폰 및 이용 방법 안내 알림톡 제공이 불가합니다.</Text></div></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}